/**
 * BARRE D'OFFRES PANIER - Gestion des produits offerts
 * Ecoute cart:updated et ajoute/retire les cadeaux automatiquement.
 * L'UI est geree cote serveur (Liquid + section rendering).
 */
(function () {
  'use strict';

  let _isUpdatingGift = false;
  let _config = null;

  function init() {
    const configEl = document.getElementById('cart-offers-config');
    if (!configEl) return;

    try {
      _config = JSON.parse(configEl.textContent);
    } catch (e) {
      console.error('[OFFERS-BAR] Invalid JSON config:', e);
      return;
    }

    if (!_config.offers || _config.offers.length === 0) return;

    _config.offers.forEach(function (offer) {
      if (offer.invalidVariantId) {
        console.warn('[OFFERS-BAR] ID variante invalide pour « ' + offer.label + ' », fallback sur la variante par défaut.');
      }
    });

    // Verifier si on a des offres de type "product"
    const hasProductOffers = _config.offers.some(function (o) { return o.type === 'product' && o.variantId; });
    if (!hasProductOffers) return;

    // Ecouter le DOM event cart:updated dispatche par cart-items
    document.addEventListener('cart:updated', function (e) {
      if (e.detail && e.detail.cart) {
        syncGifts(e.detail.cart);
      }
    });

    // Egalement ecouter ajaxProduct:added pour les ajouts depuis la page produit
    document.addEventListener('ajaxProduct:added', async function () {
      const cart = await fetchCart();
      if (cart) syncGifts(cart);
    });

    console.log('[OFFERS-BAR] Initialisé -', _config.offers.filter(function (o) { return o.type === 'product'; }).length, 'offre(s) produit');
  }

  async function fetchCart() {
    try {
      const res = await fetch(window.Shopify?.routes?.root + 'cart.js' || '/cart.js');
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return await res.json();
    } catch (e) {
      console.error('[OFFERS-BAR] Erreur fetch cart:', e);
      return null;
    }
  }

  function getEligibleTotal(cart) {
    let total = 0;
    cart.items.forEach(function (item) {
      const isGift = item.properties && item.properties._gift;
      if (!isGift) {
        total += item.final_line_price;
      }
    });
    return total;
  }

  function findGiftItem(cart, offerId) {
    for (let i = 0; i < cart.items.length; i++) {
      const item = cart.items[i];
      if (item.properties && item.properties._gift === offerId) {
        return item;
      }
    }
    return null;
  }

  async function addGiftProduct(offer) {
    console.log('[OFFERS-BAR] Ajout cadeau:', offer.label);
    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: offer.variantId,
          quantity: 1,
          properties: { _gift: offer.offerId }
        })
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return true;
    } catch (e) {
      console.error('[OFFERS-BAR] Erreur ajout cadeau:', e);
      return false;
    }
  }

  async function removeGiftProduct(giftItem) {
    console.log('[OFFERS-BAR] Retrait cadeau:', giftItem.product_title);
    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: giftItem.key,
          quantity: 0
        })
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return true;
    } catch (e) {
      console.error('[OFFERS-BAR] Erreur retrait cadeau:', e);
      return false;
    }
  }

  async function syncGifts(cart) {
    if (_isUpdatingGift) return;
    _isUpdatingGift = true;

    let needsRefresh = false;
    const total = getEligibleTotal(cart);

    try {
      for (const offer of _config.offers) {
        if (offer.type !== 'product' || !offer.variantId) continue;

        const giftInCart = findGiftItem(cart, offer.offerId);
        const shouldHaveGift = total >= offer.threshold;

        if (shouldHaveGift && !giftInCart) {
          if (await addGiftProduct(offer)) needsRefresh = true;
        } else if (!shouldHaveGift && giftInCart) {
          if (await removeGiftProduct(giftInCart)) needsRefresh = true;
        }
      }
    } finally {
      _isUpdatingGift = false;
    }

    if (needsRefresh) {
      // Demander au theme de rafraichir le cart drawer (section rendering)
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { open: false }
      }));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
